/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "quote_variant_primary": "italic",
  "quote_variant_secondary": "italic",
  "quote_size_default": "text-al-quote-md md:text-al-quote-lg",
  "quote_colors_default": "text-al-korall-600",
  "quotationMark_variant_primary": "hidden",
  "quotationMark_variant_secondary": "",
  "quotationMark_size_default": "mb-4",
  "quotationMark_colors_default": "",
  "author_variant_primary": "inline-block",
  "author_variant_secondary": "inline-block",
  "author_size_default": "text-al-body-sm md:text-al-body-md mt-1.5 md:mt-2.5",
  "author_colors_default": "",
  "variant_primary": "not-prose flex before:block before:bg-no-repeat",
  "variant_secondary": "flex items-start text-left",
  "size_default": "w-full gap-3 md:gap-6 before:w-10 before:h-[73px] before:md:w-[58px] before:md:h-[107px]",
  "colors_default": "before:bg-[url(/image/quotebox-blob.svg)]"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "Quotebox");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;